export default "__VITE_ASSET__zcfhpe8Y__"